import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  dragFileMode: null, // 拖拽文件到页面时 要去上传文件的位置
  mediaList: [], // 媒体资源列表
  chooseMediaIdList: [], // 选中的媒体资源的列表
  initialLinePosition: 0, // 初始线位置
  previewLinePosition: 0, // 预览线位置
  hoverMediaId: null, // 鼠标hover到的资源id
  clickMediaId: null, // 鼠标click到的资源id
  linkMediaList: [], // 需要link的媒体资源的列表
  filtrateMediaType: 'all', // 资源筛选类型
  outroSelectedId: '',
  introSelectedId: '',
  isShowRelinkBtn: true,
  isTopScroll: false,
  isHideDragFileMode: false,
	animationSelected: 'none', // 图片动画选中
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.TOGGLE_DRAG_FILE_MODE:
      return {
        ...state,
        dragFileMode: action.dragFileMode
      };
    case FJActionConstant.SET_MEDIA_LIST:
      return {
        ...state,
        mediaList: action.data
      };
    case FJActionConstant.SET_CHOOSE_MEDIA_LIST:
      return {
        ...state,
        chooseMediaIdList: action.data
      };
    case FJActionConstant.SET_HOVER_MEDIA_ID:
      return {
        ...state,
        hoverMediaId: action.data
      };
    case FJActionConstant.SET_INITIAL_LINE_POSITION:
      return {
        ...state,
        initialLinePosition: action.data
      };
    case FJActionConstant.SET_PREVIEW_LINE_POSITION:
      return {
        ...state,
        previewLinePosition: action.data
      };
    case FJActionConstant.SET_CLICK_MEDIA_ID:
      return {
        ...state,
        clickMediaId: action.data
      };
    case FJActionConstant.UPDATE_LINK_MEDIA_LIST:
      return {
        ...state,
        linkMediaList: action.data
      };
    case FJActionConstant.UPDATE_FILTRATE_MEDIA_TYPE:
      return {
        ...state,
        filtrateMediaType: action.filtrateMediaType
      }
    case FJActionConstant.SET_ANIMATION_INTRO_SLOT:
      return {
        ...state,
        introSelectedId: action.introSelectedId,
      }
    case FJActionConstant.SET_ANIMATION_OUTRO_SLOT:
      return {
        ...state,
        outroSelectedId: action.outroSelectedId,
      }
    case FJActionConstant.CUT_LINK_BTN:
      return {
        ...state,
        isShowRelinkBtn: !state.isShowRelinkBtn
      }
    case FJActionConstant.CUT_SCROLL_TYPE:
      return {
        ...state,
        isTopScroll: action.isTopScroll
      }
    case FJActionConstant.HIDE_DRAG_FILE_MODE:
      return {
        ...state,
        isHideDragFileMode: action.isHideDragFileMode
      }
		case FJActionConstant.SET_PHOTO_ANIMATION_SLOT:
			return {
				...state,
				animationSelected: action.animationSelected
			}
    default:
      return state;
  }
}
